export const httpUrl = 'https://www.quanruntong.com/'
export const imgpUrl = 'https://www.quanruntong.com/'
// export const httpUrl = 'https://test.quanruntong.com/'
// export const imgpUrl = 'https://test.quanruntong.com/'

// 客服聊天数据接口对应地址
export const chatUrl = 'https://chat.quanruntong.cn' // 线上
export const wsUrl = 'wss://chat.quanruntong.cn:9527' // 线上

export const vipType = [
  {vipName: '1天（日卡）', price: 0.01},
  {vipName: '7天（周卡）', price: 15},
  {vipName: '30天（月卡）', price: 29},
  {vipName: '30天（SVIP月卡）', price: 59},
  {vipName: '90天（季卡）', price: 89},
  {vipName: '180天（半年卡）', price: 169},
  {vipName: '360天（年卡）', price: 199}
]
export const expressComp = {
  ems: 'EMS',
  shunfeng: '顺丰快递',
  shentong: '申通快递',
  tiantian: '天天快递',
  yuantong: '圆通速递',
  yunda: '韵达快运',
  zhongtong: '中通速递'
}



// WEBPACK FOOTER //
// ./src/config/index.js